/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CorrectionEvent } from '../models/CorrectionEvent'
import type { WorkdayArray } from '../models/WorkdayArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class CorrectionService {
  /**
   * 👤 Get workdays with events of the employee that is associated with the authenticated user
   * @returns any OK
   * @throws ApiError
   */
  public static getWorkdaysForCorrection(): CancelablePromise<{
    data?: WorkdayArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/correction',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
  /**
   * 👤 Update an event
   * @param eventId event id of the event to update
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static updateEvent(
    eventId: number,
    requestBody?: CorrectionEvent,
  ): CancelablePromise<{
    data?: {
      transactionId: number
      firstInstanceToRefresh: string
      lastInstanceToRefresh: string
    }
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/correction/updateEvent/{eventId}',
      path: {
        eventId: eventId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Store an event
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeEvent(requestBody?: CorrectionEvent): CancelablePromise<{
    data?: {
      transactionId: number
      event_uuid: string
    }
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/correction/storeEvent',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Delete an event
   * @param eventId event id of the event to delete
   * @returns any OK
   * @throws ApiError
   */
  public static deleteEvent(eventId: number): CancelablePromise<{
    data?: {
      transactionId: number
    }
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/correction/deleteEvent/{eventId}',
      path: {
        eventId: eventId,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Undo a correction by transactionId
   * @param transactionId transaction id of the transaction to be undone
   * @returns any OK
   * @throws ApiError
   */
  public static undoTransaction(transactionId: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/correction/undo/{transactionId}',
      path: {
        transactionId: transactionId,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
}
